export default __webpack_public_path__ + "static/media/1043.0ff596b9.png";